import { Separator } from '@carboncopyco/ui';
import type { TourActionsDropdownContentProps } from './types';

export const TourActionsDropdownContent = ({
  previewTour,
  duplicateTour,
  copyTour,
  copyUrl,
  moveTour,
  archiveTour,
}: TourActionsDropdownContentProps) => {
  return (
    <div className="p-2 flex flex-col gap-2">
      <div>{previewTour}</div>
      {(duplicateTour || copyTour || moveTour) && <Separator horizontal />}
      <div>
        {duplicateTour}
        {copyTour}
        {moveTour}
        {copyUrl}
      </div>
      {archiveTour && <Separator horizontal />}
      <div>{archiveTour}</div>
    </div>
  );
};
